// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"678d70fe","127":"a83bbf66","141":"5f617a9e","351":"df58ba6a","384":"75bd549d","453":"eafda266","539":"7311b139","713":"73e22935","812":"5e29562c","821":"bc937399","860":"03fe235f","865":"2effacc2","919":"4add92ec","942":"e155d929","961":"833c4780","975":"cf410e1e"}[chunkId] + ".chunk.js";
};